import * as React from 'react';
import Col from 'react-bootstrap/Col';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Help} from './buttons';
import cloneDeep from 'lodash/cloneDeep';
import onClickOutside from 'react-onclickoutside';
import isEqual from 'lodash/isEqual';

export default class Ranges extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      range: this.calculateDefaultRange(this.props.ranges),
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    window.isequal = isEqual;
    if (
      !isEqual(
        {...nextProps.defaultRange, from: 10, to: 10},
        {...this.props.defaultRange, from: 10, to: 10}
      )
    ) {
      console.info(
        'recalculating default range next=',
        nextProps.defaultRange,
        'current=',
        this.props.defaultRange
      );
      this.setState({
        range: this.calculateDefaultRange(
          this.props.ranges,
          nextProps.defaultRange
        ),
      });
    }
  }

  render() {
    return (
      <>
        <Row style={{display: 'flex', alignItems: 'center'}}>
          <Col md={1}>BPM From</Col>
          <Col md={1}>BPM To</Col>
          {this.props.header}
          <Col></Col>
        </Row>
        {this.props.ranges.map((range, index) => {
          return (
            <div key={index}>
              <Row>&nbsp;</Row>
              <Row style={{display: 'flex', alignItems: 'center'}}>
                <Col md={1}>
                  <MyC
                    value={range.from}
                    recalculate={this.recalculate(index)}
                    onChange={this.updateFrom(index)}
                  />
                </Col>
                <Col md={1}>
                  <MyC
                    value={range.to}
                    recalculate={this.recalculate(index)}
                    onChange={this.updateTo(index)}
                  />
                </Col>
                {this.props.rangeConfiguration(range, this.updateRange(index))}
                {!this.props.keepLength && (
                  <Col>
                    <Form>
                      <Help
                        onClick={() => {
                          let ranges = cloneDeep(this.props.ranges);
                          ranges.splice(index, 1);
                          this.props.onRangesChange(ranges);
                        }}
                      >
                        {' '}
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Help>
                    </Form>
                  </Col>
                )}
              </Row>
            </div>
          );
        })}

        <Row> &nbsp;</Row>
        {!this.props.keepLength && (
          <>
            <hr />
            <Row style={{display: 'flex', alignItems: 'center'}} key={4}>
              <Col md={1} key={1}>
                <Form.Control
                  type={'number'}
                  value={this.state.range.from}
                  onChange={(e) => {
                    this.setState({
                      range: {
                        ...this.state.range,
                        from: parseInt(e.target.value),
                      },
                    });
                  }}
                />
              </Col>
              <Col md={1} key={2}>
                <Form.Control
                  type={'number'}
                  value={this.state.range.to}
                  onChange={(e) => {
                    this.setState({
                      range: {
                        ...this.state.range,
                        to: parseInt(e.target.value),
                      },
                    });
                  }}
                />
              </Col>
              {this.props.rangeConfiguration(this.state.range, (range) =>
                this.setState({range})
              )}

              <Col md={3}>
                <Help onClick={this.insert}>
                  {' '}
                  <FontAwesomeIcon icon={faPlus} />
                </Help>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }

  recalculate = (index) => () => {
    this.props.onRangesChange(this.adjust(index, this.props.ranges));
  };

  adjust = (index, rangess) => {
    let ranges = cloneDeep(rangess);
    let range = ranges[index];
    if (range.from > range.to) {
      ranges.splice(index, 1);
      return ranges;
    }

    let prevRemove = false;

    if (index - 1 >= 0) {
      let prevRange = ranges[index - 1];
      if (prevRange.to < range.from) {
      } else if (prevRange.from > range.from) {
        prevRemove = true;
      } else {
        if (prevRange.from === prevRange.to) {
          prevRemove = true;
        } else {
          prevRange.to = range.from - 1;
          if (prevRange.from >= prevRange.to) {
            prevRemove = true;
          }
        }
      }
    }
    let nextRangeRemove = false;

    if (index + 1 < ranges.length) {
      let nextRange = ranges[index + 1];
      if (range.to < nextRange.from) {
      } else if (range.to > nextRange.to) {
        nextRangeRemove = true;
      } else {
        if (nextRange.from === nextRange.to) {
          nextRangeRemove = true;
        } else {
          nextRange.from = range.to + 1;
          if (nextRange.from >= nextRange.to) {
            nextRangeRemove = true;
          }
        }
      }
    }

    if (nextRangeRemove) {
      ranges.splice(index + 1, 1);
    }

    if (prevRemove) {
      ranges.splice(index - 1, 1);
      return this.adjust(index - 1, ranges);
    } else if (nextRangeRemove) {
      return this.adjust(index, ranges);
    } else {
      return ranges;
    }
  };
  clean = (ranges) => {
    let indexesToRemove = [];
    ranges.forEach((element, index) => {
      if (element.from >= element.to) {
        indexesToRemove.push(index);
      }
    });
    indexesToRemove.forEach((indexToRemove) => ranges.splice(indexToRemove, 1));
    return ranges;
  };

  updateFrom =
    (index) =>
    (from, recalculate = false) => {
      let ranges = cloneDeep(this.props.ranges);
      ranges[index].from = parseInt(from);
      if (parseInt(from) < 0) {
        return;
      }
      if (recalculate) {
        console.info('recalculating index=', index, 'from=', from);
        this.props.onRangesChange(this.adjust(index, ranges));
      } else {
        this.props.onRangesChange(ranges);
      }
    };

  updateTo =
    (index) =>
    (to, recalculate = false) => {
      let ranges = cloneDeep(this.props.ranges);
      ranges[index].to = parseInt(to);
      if (parseInt(to) < 0) {
        return;
      }
      if (recalculate) {
        console.info('recalculating index=', index, 'to=', to);
        this.props.onRangesChange(this.adjust(index, ranges));
      } else {
        this.props.onRangesChange(ranges);
      }
    };

  updateRange = (index) => (range) => {
    let ranges = cloneDeep(this.props.ranges);
    ranges[index] = range;
    this.props.onRangesChange(ranges);
  };

  insert = () => {
    let newRange = this.state.range;

    console.info('new range', newRange);
    let insertIndex = -1;

    let ranges = cloneDeep(this.props.ranges);

    for (let i = 0; i < ranges.length; i++) {
      if (ranges[i].from > newRange.from) {
        insertIndex = i;
        break;
      }
    }

    if (insertIndex === -1) {
      ranges.push(newRange);
      insertIndex = ranges.length - 1;
    } else {
      ranges.splice(insertIndex, 0, newRange);
    }

    let newRanges = this.adjust(insertIndex, ranges);
    this.props.onRangesChange(newRanges);

    this.setState({range: this.calculateDefaultRange(newRanges)});
  };

  calculateDefaultRange = (ranges, defaultRange) => {
    if (ranges.length === 0) {
      return defaultRange ? defaultRange : this.props.defaultRange;
    } else {
      if (ranges) {
        let newDefaultRange = cloneDeep(ranges[ranges.length - 1]);
        newDefaultRange.from = newDefaultRange.to + 1;
        newDefaultRange.to = newDefaultRange.to + 10;
        if (defaultRange) {
          newDefaultRange.value = defaultRange.value;
        }

        return newDefaultRange;
      }
      return defaultRange ? defaultRange : this.props.defaultRange;
    }
  };
}

class MyComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {isChanged: false};
  }

  render() {
    return (
      <Form>
        <Form.Control
          type={'number'}
          value={this.props.value}
          onChange={(e) => {
            if (
              parseInt(this.props.value) === parseInt(e.target.value) + 1 ||
              parseInt(this.props.value) === parseInt(e.target.value) - 1
            ) {
              this.props.onChange(e.target.value, true);
            } else {
              this.props.onChange(e.target.value);
              this.setState({isChanged: true});
            }
          }}
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.props.recalculate();
            }
          }}
        />
      </Form>
    );
  }

  handleClickOutside = (_) => {
    if (this.state.isChanged) {
      this.props.recalculate();
      this.setState({isChanged: false});
    }
  };
}

const MyC = onClickOutside(MyComponent);
